// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be990a64","455":"65fe51b1","821":"e56f04b0","977":"4d73845d"}[chunkId] + ".chunk.js";
};